<template>
<div class="daoh2">
<!--    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">-->
<!--        <router-link v-for="item1 in item" :key="item1.id" :to="item1.path" >-->
<!--            <el-menu-item :index="item1.id">-->
<!--                <span slot="title">{{item1.label}}</span>-->
<!--            </el-menu-item>-->
<!--        </router-link>-->
<!--    </el-menu>-->
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      isCollapse: false,
      item:[],
      items_list1:[
          {
            id:'3001',
            label: '账单管理',
            icon: 'mdi-home-outline ',
            path:'/Order/list',
            pid:3,
          },
        {
          id:'2001',
          label: '项目管理',
          icon: 'mdi-home-outline ',
          path:'/Order/index',
          pid:2,
        },
          {
            id:'3002',
            label: '缴费订单',
            icon: 'mdi-home-outline ',
            path:'/Order/listDate',
            pid:3,
          },
          {
            id:'3003',
            label: '批量折扣',
            icon: 'mdi-home-outline ',
            path:'/Order/discountExcel',
            pid:3,
          },
          {
            id:'3004',
            label: '财务报表',
            icon: 'mdi-home-outline ',
            path:'/Order/financeReport',
            pid:3,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=3',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
    },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/Index.vue